<template>
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="28" height="28" rx="14" fill="#ECEFF1" />
    <g opacity="0.4" clip-path="url(#clip0_2424_53393)">
      <path
        d="M15.6663 15.8763V17.618C14.9121 17.3513 14.1049 17.2696 13.3125 17.3795C12.5201 17.4894 11.7657 17.7879 11.1125 18.2498C10.4594 18.7118 9.92663 19.3237 9.55898 20.0342C9.19133 20.7447 8.99952 21.533 8.99967 22.333L7.33301 22.3322C7.33275 21.3146 7.56544 20.3104 8.01326 19.3967C8.46107 18.4829 9.11212 17.6838 9.91652 17.0605C10.7209 16.4373 11.6573 16.0065 12.654 15.801C13.6506 15.5956 14.6811 15.6211 15.6663 15.8755V15.8763ZM13.9997 14.833C11.2372 14.833 8.99967 12.5955 8.99967 9.83301C8.99967 7.07051 11.2372 4.83301 13.9997 4.83301C16.7622 4.83301 18.9997 7.07051 18.9997 9.83301C18.9997 12.5955 16.7622 14.833 13.9997 14.833ZM13.9997 13.1663C15.8413 13.1663 17.333 11.6747 17.333 9.83301C17.333 7.99134 15.8413 6.49967 13.9997 6.49967C12.158 6.49967 10.6663 7.99134 10.6663 9.83301C10.6663 11.6747 12.158 13.1663 13.9997 13.1663ZM20.1813 18.1663H23.1697V19.833H20.1813L21.7055 21.3563L20.5272 22.5355L16.9913 18.9997L20.5272 15.4638L21.7055 16.643L20.1813 18.1663Z"
        fill="#263238" />
    </g>
    <defs>
      <clipPath id="clip0_2424_53393">
        <rect width="20" height="20" fill="white" transform="translate(4 4)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
}
</script>